import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getClinicsOfDoctor } from 'Redux/modules/clinics/actions';

const useClinic = doctorId => {
  const dispatch = useDispatch();
  const clinics = useSelector(state => state.clinics.list, shallowEqual);
  const getClinics = () => dispatch(getClinicsOfDoctor(doctorId));

  return { clinics, getClinics };
};

export default useClinic;
